import React from "react";
import EngineeringIcon from "@mui/icons-material/Engineering";
import "./UnderMaintenance.scss";
const UnderMaintenance = () => {
	return (
		<div className="mainenance-container">
			<div className="icon-container">
				<EngineeringIcon sx={{ fontSize: 100, color: "#012c51" }} />
			</div>
			<div className="su-mtnce">System Under Maintenance</div>
			<div className="su-mtnce-desc">
				<p>
					The ERP system is currently undergoing scheduled maintenance and is temporarily unavailable. This necessary work ensures the system's stability and security.
					<br />
					<h3>Maintenance Window (UTC):</h3>
					<strong>Start:</strong> Friday, November 26, 2025, 1:00 PM UTC
					<br />
					<strong>End:</strong> Friday, November 26, 2025, 6:00 PM UTC
					<br />
					<em>
						(Note: For users in Central Standard Time (CST), this corresponds to 
						7:00 AM CST to 12:00 PM (Noon) CST on November 26th.)
					</em>
					<br />
					We apologize for the interruption and expect services to be fully restored 
					promptly by <strong>6:00 PM UTC</strong>.
				</p>
			</div>
		</div>
	);
};
export default UnderMaintenance;
